import * as React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppAction } from '../../config/appConfig'
import { MenuItemKey } from '../../components/MainMenu'
import { FileAction } from '../../config/fileConfig'
import BaseFileOverview from './BaseFileOverview'

export default function FileOverview() {
    const dispatch = useDispatch()

    //Reset breadcrumbs and data
    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Files] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [])

    return <BaseFileOverview localStorageKeyPrefix={'HammockFileOverview'} />
}
